/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Click_Link_ResetInputs */



/**
* | output |
* | --- |
* | "Click the link to reset your password." |
*
* @param {Login_Click_Link_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_click_link_reset = /** @type {((inputs?: Login_Click_Link_ResetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Click_Link_ResetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez sur le lien pour réinitialiser votre mot de passe.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic en el enlace para restablecer su contraseña.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Clique no link para redefinir sua senha.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clicca sul link per reimpostare la tua password.")
	return /** @type {LocalizedString} */ ("Click the link to reset your password.")
});